import CircleProgressBar from './CircleProgressBar';

export default CircleProgressBar;
